import { useQuery } from "@tanstack/react-query";

import { userByIdOptions } from "@dashboard/api/queryApi";

export function UserDisplay({ userId, className }: { userId: number; className?: string }) {
    const { data: user } = useQuery(userByIdOptions({ id: userId }));
    return (
        <span className={className}>
            {user?.firstName} {user?.lastName}
        </span>
    );
}
